import React from "react";
import { useTooltip } from "../../stores/useTooltip";

type Props = {
  children: React.ReactElement;
  type: "top" | "right" | "bottom" | "left";
  tooltipText: string;
  bigFont?: boolean;
};

function TooltipWrapper({ children, type, tooltipText, bigFont = false }: Props) {
  const setTooltipInfo = useTooltip(state => state.setTooltipInfo);

  function getTopPosition(node: HTMLElement) {
    if (type === "bottom") {
      return node.getBoundingClientRect().bottom;
    } else if (type === "right") {
      return node.getBoundingClientRect().top + node.getBoundingClientRect().height / 2;
    } else if (type === "top") {
      return node.getBoundingClientRect().top;
    }
  }

  function getLeftPosition(node: HTMLElement) {
    if (type === "bottom" || type === "top") {
      return node.getBoundingClientRect().left + node.getBoundingClientRect().width / 2;
    } else if (type === "right") {
      return node.getBoundingClientRect().right;
    }
  }

  return (
    <>
      {React.cloneElement(children, {
        onMouseEnter: (e: MouseEvent) => {
          const node = e.target as HTMLElement;
          setTooltipInfo({
            top: getTopPosition(node) as number,
            left: getLeftPosition(node) as number,
            type,
            tooltipText,
            bigFont,
          });
        },
        onMouseLeave: () => {
          setTooltipInfo(null);
        },
      })}
    </>
  );
}

export default TooltipWrapper;
